import {
  Navigate,
  useLocation,
  useParams,
  useSearchParams,
} from "react-router-dom";
import { skipToken } from "@reduxjs/toolkit/query";

import BaseSpinner from "@/components_v2/Spiner/BaseSpinner";
import SurveyOverview from "@/features/survey/overview";
import { useGetSurveyByIdQuery } from "@/redux/service";
import { useOrganizationId } from "@/shared/hooks/useOrganizationId";

const SurveyOverviewPage = () => {
  const { surveyId } = useParams<{ surveyId: string }>();
  const [searchParams] = useSearchParams();
  const location = useLocation();
  const currentOrganizationId = useOrganizationId();

  const organizationId =
    searchParams.get("organization") || currentOrganizationId;

  const { data: survey, isError } = useGetSurveyByIdQuery(
    surveyId
      ? { surveyId, filters: { organization: organizationId } }
      : skipToken,
  );

  if (location.pathname.includes("public")) {
    return (
      <Navigate to={`/reports/${surveyId}/report${location.search}`} replace />
    );
  }

  if (isError) {
    return <Navigate to="/" />;
  }

  if (!survey) {
    return (
      <div className="survey-overview-page">
        <div className="survey-overview-body flex justify-center full-width">
          <BaseSpinner />
        </div>
      </div>
    );
  }

  return <SurveyOverview survey={survey} organizationId={organizationId} />;
};

export default SurveyOverviewPage;
